var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",attrs:{"id":"huro-app"}},[_c('div',{staticClass:"app-overlay"}),_vm._v(" "),(_vm.$route.name != 'Login')?_c('Header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"view-wrapper is-webapp",class:_vm.$route.name == 'ExerciseDetail' ? 'exercise-detail' : '',style:(_vm.$route.name == 'ExerciseDetail' ||
      _vm.$route.name == 'CourseDetail' ||
      _vm.$route.name == 'ForKids' ||
      _vm.$route.name == 'Siir' ||
      _vm.$route.name == 'Tekerleme' ||
      _vm.$route.params.type == 'kare-okuma' ||
      _vm.$route.params.type == 'takistoskop' ||
      _vm.$route.params.type == 'kelime-egzersizi' ||
      _vm.$route.params.type == 'ileri-seviye-kare-okuma' ||
      _vm.$route.params.type == 'siir' ||
      _vm.$route.params.type == 'ileri-seviye-siir' ||
      _vm.$route.params.type == 'tekerleme' ||
      _vm.$route.params.type == 'ileri-seviye-tekerleme' ||
      _vm.$route.params.type == 'heceleme' ||
      _vm.$route.params.type == 'metin-okuma' ||
      _vm.$route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
      _vm.$route.params.type == 'odak-okuma' ||
      _vm.$route.name == 'RepeatCourse'
        ? 'padding: 0px !important;'
        : _vm.$route.name == 'Login'
        ? 'padding: 0px !important; margin: 0px !important; '
        : 'padding-left: 250px !important; background-image: url(/static/Egzersiz%20Ekranı.png);        min-height: 100vh;        background-size: auto 100%;        background-repeat: no-repeat;        background-position: center;        background-position-x: 250px;'),attrs:{"id":"app-onboarding","page":_vm.$route.name,"data-page-title":"Blank Template","data-naver-offset":"214","data-menu-item":"#layouts-navbar-menu","data-mobile-item":"#home-sidebar-menu-mobile"}},[(_vm.$route.name != 'Login')?_c('LeftMenu',{staticStyle:{"transition":"0.3s"},style:(_vm.$route.name == 'ExerciseDetail' ||
        _vm.$route.name == 'CourseDetail' ||
        _vm.$route.name == 'ForKids' ||
        _vm.$route.name == 'Siir' ||
        _vm.$route.name == 'Tekerleme' ||
        _vm.$route.params.type == 'kare-okuma' ||
        _vm.$route.params.type == 'takistoskop' ||
        _vm.$route.params.type == 'kelime-egzersizi' ||
        _vm.$route.params.type == 'ileri-seviye-kare-okuma' ||
        _vm.$route.params.type == 'siir' ||
        _vm.$route.params.type == 'ileri-seviye-siir' ||
        _vm.$route.params.type == 'tekerleme' ||
        _vm.$route.params.type == 'ileri-seviye-tekerleme' ||
        _vm.$route.params.type == 'heceleme' ||
        _vm.$route.params.type == 'metin-okuma' ||
        _vm.$route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
        _vm.$route.params.type == 'odak-okuma' ||
        _vm.$route.name == 'RepeatCourse'
          ? 'left: -250px;'
          : '0px;')}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-content-wrapper",style:(_vm.$route.name == 'Login' ||
        _vm.$route.name == 'CourseDetail' ||
        _vm.$route.name == 'ForKids' ||
        _vm.$route.name == 'Siir' ||
        _vm.$route.name == 'Tekerleme' ||
        _vm.$route.name == 'ExercisesChild' ||
        _vm.$route.params.type == 'kare-okuma' ||
        _vm.$route.params.type == 'takistoskop' ||
        _vm.$route.params.type == 'kelime-egzersizi' ||
        _vm.$route.params.type == 'ileri-seviye-kare-okuma' ||
        _vm.$route.params.type == 'siir' ||
        _vm.$route.params.type == 'ileri-seviye-siir' ||
        _vm.$route.params.type == 'tekerleme' ||
        _vm.$route.params.type == 'ileri-seviye-tekerleme' ||
        _vm.$route.params.type == 'heceleme' ||
        _vm.$route.params.type == 'metin-okuma' ||
        _vm.$route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
        _vm.$route.name == 'RepeatCourse' ||
        _vm.$route.params.type == 'odak-okuma' ||
        _vm.$route.name == 'Home'
          ? 'max-width: 100%;'
          : '')},[_c('div',{staticClass:"page-content is-relative",style:(_vm.$route.name == 'Login' ||
          _vm.$route.name == 'CourseDetail' ||
          _vm.$route.name == 'RepeatCourse' ||
          _vm.$route.name == 'ForKids' ||
          _vm.$route.name == 'Siir' ||
          _vm.$route.name == 'Tekerleme' ||
          _vm.$route.name == 'ExercisesChild' ||
          _vm.$route.params.type == 'kare-okuma' ||
          _vm.$route.params.type == 'takistoskop' ||
          _vm.$route.params.type == 'kelime-egzersizi' ||
          _vm.$route.params.type == 'ileri-seviye-kare-okuma' ||
          _vm.$route.params.type == 'siir' ||
          _vm.$route.params.type == 'ileri-seviye-siir' ||
          _vm.$route.params.type == 'tekerleme' ||
          _vm.$route.params.type == 'ileri-seviye-tekerleme' ||
          _vm.$route.params.type == 'heceleme' ||
          _vm.$route.params.type == 'metin-okuma' ||
          _vm.$route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
          _vm.$route.params.type == 'odak-okuma' ||
          _vm.$route.name == 'Home'
            ? 'padding: 0px !important;'
            : '')},[_c('div',{staticClass:"page-content-inner",style:(_vm.$route.name == 'Login' ||
            _vm.$route.name == 'CourseDetail' ||
            _vm.$route.name == 'RepeatCourse' ||
            _vm.$route.name == 'ForKids' ||
            _vm.$route.name == 'Siir' ||
            _vm.$route.name == 'Tekerleme' ||
            _vm.$route.name == 'ExercisesChild' ||
            _vm.$route.params.type == 'kare-okuma' ||
            _vm.$route.params.type == 'takistoskop' ||
            _vm.$route.params.type == 'kelime-egzersizi' ||
            _vm.$route.params.type == 'ileri-seviye-kare-okuma' ||
            _vm.$route.params.type == 'siir' ||
            _vm.$route.params.type == 'ileri-seviye-siir' ||
            _vm.$route.params.type == 'tekerleme' ||
            _vm.$route.params.type == 'ileri-seviye-tekerleme' ||
            _vm.$route.params.type == 'heceleme' ||
            _vm.$route.params.type == 'metin-okuma' ||
            _vm.$route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
            _vm.$route.params.type == 'odak-okuma' ||
            _vm.$route.name == 'Home'
              ? 'margin: 0px;'
              : '')},[_c('router-view')],1)])])],1),_vm._v(" "),(_vm.$store.state.user != null)?_c('el-dialog',{attrs:{"id":"emotion_modal","visible":_vm.welcomeVideoModal,"close-on-click-modal":false,"close-on-press-escape":false,"show-close":false,"width":"700px"},on:{"update:visible":function($event){_vm.welcomeVideoModal=$event}}},[(_vm.ended === false)?_c('video',{staticStyle:{"background-color":"transparent","width":"100%","height":"100%"},attrs:{"autoplay":"","src":_vm.videoUrl,"id":"player"}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.state.user != null)?_c('el-dialog',{attrs:{"id":"emotion_modal","visible":_vm.visible,"close-on-click-modal":false,"close-on-press-escape":false,"show-close":false,"width":"700px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("app.hello"))+" "+_vm._s(_vm.$store.state.user.firstname))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"19px","text-align":"center","margin-bottom":"20px","word-break":"break-word"}},[_vm._v("\n        "+_vm._s(_vm.$t("app.hello_description"))+"\n      ")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("app.howareu")))]),_vm._v(" "),_c('el-rate',{attrs:{"show-text":true,"icon-classes":_vm.iconClasses,"texts":[
          _vm.$t('app.cokkotu'),
          _vm.$t('app.kotu'),
          _vm.$t('app.idareeder'),
          _vm.$t('app.good'),
          _vm.$t('app.super') ],"void-icon-class":"fas fa-meh-blank","colors":['#99A9BF', '#F7BA2A', '#FF9900']},model:{value:(_vm.emotion),callback:function ($$v) {_vm.emotion=$$v},expression:"emotion"}}),_vm._v(" "),_c('h4',{staticClass:"mt-5 mb-2"},[_vm._v(_vm._s(_vm.$t("app.sleep")))]),_vm._v(" "),_c('el-radio-group',{attrs:{"size":"medium"},model:{value:(_vm.sleep),callback:function ($$v) {_vm.sleep=$$v},expression:"sleep"}},_vm._l((_vm.hours),function(i){return _c('el-radio-button',{attrs:{"label":i.value}},[_vm._v(_vm._s(i.title))])}),1),_vm._v(" "),_c('h4',{staticClass:"mt-5 mb-2"},[_vm._v("Kaç Sayfa Kitap Okudunuz?")]),_vm._v(" "),_c('el-input-number',{model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),_vm._v(" "),_c('h4',{staticClass:"mt-5 mb-2"},[_vm._v("Kaç Dakika Kitap Okudunuz?")]),_vm._v(" "),_c('el-input-number',{model:{value:(_vm.read_time),callback:function ($$v) {_vm.read_time=$$v},expression:"read_time"}}),_vm._v(" "),(_vm.sleep != null && _vm.emotion != 0)?_c('el-button',{staticStyle:{"width":"40%","padding":"10px 15px","font-size":"18px","margin-top":"40px"},attrs:{"round":"","type":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("app.save"))+"\n      ")]):_vm._e()],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6b89648","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 